// extracted by mini-css-extract-plugin
module.exports = {"gridWrapper":"styles-module--gridWrapper--3rsFN","twoColumns":"styles-module--twoColumns--3EOV7"};